var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.text)?_c('div',{staticClass:"plugin-home-common-title",class:( _obj = { '_has-subtitle': !!_vm.subtitle }, _obj[("_" + _vm.theme)] = true, _obj )},[_c('h2',{domProps:{"textContent":_vm._s(_vm.text)}}),(_vm.subtitle)?_c('div',{staticClass:"plugin-home-common-title__subtitle",domProps:{"textContent":_vm._s(_vm.subtitle)}}):_vm._e()]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }